import { selectAppDomain, selectSelectedCompanyDocument, useAppSelector } from '@ibk/shared-config';
import { useFeatureFlag } from '@ibk/shared-feature-flags';
import { AppDomain, FeatureFlagUseCase } from '@ibk/shared-types';
import { useSearchAccountantEmissorContractsQuery, useSearchClientEmissorContractsQuery, } from '../services/contractStatusApi';
import { EmissorContractStatus } from '../types/contractStatus';
export function useHappyHolidaysHomeBannerEligibility(enabled = true) {
    const appDomain = useAppSelector(selectAppDomain);
    const document = useAppSelector(selectSelectedCompanyDocument);
    const { isFeatureFlagWhiteListed } = useFeatureFlag();
    const isCampaignEnabled = enabled && isFeatureFlagWhiteListed(FeatureFlagUseCase.BENEFICIOS_RECARGA_BOAS_FESTAS);
    const isSupportedDomain = appDomain === AppDomain.ESCRITORIO || appDomain === AppDomain.EMPRESA;
    const skip = !isCampaignEnabled || !document || !isSupportedDomain;
    const query = {
        document: document ?? undefined,
        status: [EmissorContractStatus.REQUESTED, EmissorContractStatus.CREATED, EmissorContractStatus.ACTIVATED],
        limit: 1,
        sort: '-createdAt',
    };
    const accountant = useSearchAccountantEmissorContractsQuery(query, {
        skip: skip || appDomain !== AppDomain.ESCRITORIO,
        refetchOnMountOrArgChange: true,
    });
    const client = useSearchClientEmissorContractsQuery(query, {
        skip: skip || appDomain !== AppDomain.EMPRESA,
        refetchOnMountOrArgChange: true,
    });
    const contracts = appDomain === AppDomain.ESCRITORIO ? accountant : client;
    return (!skip && !contracts.isFetching && !contracts.isLoading && !contracts.isError && contracts.currentData?.length === 0);
}
